import { render, staticRenderFns } from "./SliderRow.vue?vue&type=template&id=8de51bee&scoped=true"
import script from "./SliderRow.vue?vue&type=script&lang=js"
export * from "./SliderRow.vue?vue&type=script&lang=js"
import style0 from "./SliderRow.vue?vue&type=style&index=0&id=8de51bee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de51bee",
  null
  
)

export default component.exports